import { TagStyle } from '@hh.ru/magritte-ui';

export const getTagStyleByIndex = (length: number, i: number): TagStyle => {
    if (i / length < 0.33) {
        return 'special';
    }
    if (i / length < 0.66) {
        return 'positive';
    }
    return 'neutral';
};
